import React from 'react';
import NumberFormat from 'react-number-format';

function CampoDecimal(props) {
    const {inputRef,...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            decimalScale="2"
            decimalSeparator=","  
            allowNegative ="false"
            fixedDecimalScale="false"   
        />
    )
}

export default CampoDecimal;